/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { user?: HubAPI.User } | undefined,
) {
  const { user } = initialState ?? {};
  const role = String(user?.org_role || user?.role || '').toLowerCase();

  return {
    ...user?.permissions,
    xudo: user?.org_id === 1,
    xudoGroup: user?.org_id === 1 || user?.is_hub_owner === true,
    hubOwner: user?.is_hub_owner === true,
    owner: role === 'owner',
  };
}
